import React, { useMemo } from 'react';
import Markdown, { defaultRenderers } from 'components/Markdown';
import PassthroughLink from '../PassthroughLink';

const createRenderers = (isPublic: boolean) => ({
  ...defaultRenderers,
  link: ({ children, href }: { href: string; children: React.ReactNode }) => (
    <PassthroughLink href={href} isPublic={isPublic}>
      {children}
    </PassthroughLink>
  )
});

interface LegalDocArticleProps {
  legalDoc: {
    content: string;
  };
  isPublic: boolean;
}

const LegalDocArticle = ({ legalDoc, isPublic = false }: LegalDocArticleProps) => {
  const renderers = useMemo(() => createRenderers(isPublic), [isPublic]);
  return (
    /* @ts-ignore -- Markdown is not typescript component. "renderers" default type is not right */
    <Markdown content={legalDoc.content} renderers={renderers} />
  );
};

export default LegalDocArticle;
